import { render, staticRenderFns } from "./InstitutionItemRegister.vue?vue&type=template&id=140aacb1"
import script from "./InstitutionItemRegister.vue?vue&type=script&lang=js"
export * from "./InstitutionItemRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140aacb1')) {
      api.createRecord('140aacb1', component.options)
    } else {
      api.reload('140aacb1', component.options)
    }
    module.hot.accept("./InstitutionItemRegister.vue?vue&type=template&id=140aacb1", function () {
      api.rerender('140aacb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/integration/InstitutionItemRegister.vue"
export default component.exports